<template>
<v-dialog v-model="displayForm" width="500">
  <v-card>
    <post-gallary
      :post-gallary="postGallary"
      :selectdPostIds='postListPostIds'
      @close-post-gallary="postGallary = false"
      @select-post="selectPost"
    />
    <v-card-title />
    <v-card-text>
      <v-form ref="featureForm">
        <v-select
          v-model="feature.pageType"
          :items="pageTypes"
          item-text="type"
          class="mb-3"
          item-value="value"
          :rules="[presenceValidation]"
          autofocus
        >
          <template v-slot:label>
            <InputLabel label-name="特集の種類" :required="true" />
          </template>
        </v-select>
        <v-text-field
          v-model="feature.title"
          :counter="40"
          :rules="[presenceValidation]"
        >
          <template v-slot:label>
            <InputLabel label-name="タイトル" :required="true" />
          </template>
        </v-text-field>
        <v-text-field
          v-model.number="feature.priority"
          type="number"
          min="0"
          :rules="[positiveNumberPresenceValidation]"
        >
          <template v-slot:label>
            <InputLabel label-name="表示順" :required="true" />
          </template>
        </v-text-field>
        <v-textarea v-model="feature.description">
          <template v-slot:label>
            <InputLabel label-name="説明文" />
          </template>
        </v-textarea>
        <div class='mt-4'>
          ※利用しているデザインテンプレートによって、必要な画像を設定してください。
        </div>
        <ImageFormAndThumbnail
          ref="headlineImage"
          label-name='見出し画像'
          thumbnailWidth='300px'
          thumbnailHeight='90px'
          hint="※推奨サイズ：1500×450（単位はpx）"
          :propsImagePreviewURL="feature.headlineImage ? feature.headlineImage.url : ''"
          @change-image-file="(value) => feature.headlineImage = value"
        ></ImageFormAndThumbnail>
        <ImageFormAndThumbnail
          ref="headlineImage3X2"
          label-name='見出し画像(縦横比3x2)'
          thumbnailWidth='180px'
          thumbnailHeight='120px'
          hint="※推奨サイズ：900×600（単位はpx）"
          :propsImagePreviewURL="feature.headlineImage3X2 ? feature.headlineImage3X2.url : ''"
          @change-image-file="(value) => feature.headlineImage3X2 = value"
        ></ImageFormAndThumbnail>
        <ImageFormAndThumbnail
          ref="coverImage3X2"
          label-name='カバー画像(縦横比3x2)'
          thumbnailWidth='180px'
          thumbnailHeight='120px'
          hint="※推奨サイズ：900×600（単位はpx）"
          :propsImagePreviewURL="feature.coverImage3X2 ? feature.coverImage3X2.url : ''"
          @change-image-file="(value) => feature.coverImage3X2 = value"
        ></ImageFormAndThumbnail>
        <v-switch
          v-model="feature.isPublic"
          class="p-settingForm--inputSwitch"
          label="公開する"
        />
        <v-switch
          v-model="feature.isDisplayed"
          class="p-settingForm--inputSwitch"
          label="トップ・サイドバーに表示する"
        />
        <div v-if="feature.pageType == 'external_page'">
          <v-text-field
            v-model="feature.link"
            class="mb-3"
            persistent-hint
            :rules="[urlValidation]"
          >
            <template v-slot:label>
              <InputLabel label-name="ページリンク" :required="true" />
            </template>
          </v-text-field>
        </div>
        <div v-else-if="feature.pageType == 'post_summarize'">
          <v-text-field
            v-model="feature.slug"
            class="mb-3"
            persistent-hint
            label="パーマリンク"
            :hint="`url: /features/${feature.slug} が割り当てられます`"
            :rules="[presenceValidation]"
          >
            <template v-slot:label>
              <InputLabel label-name="パーマリンク" :required="true" />
            </template>
          </v-text-field>
          <PostListSelectable
            :items="feature.featureItems"
            @post-gallary="postGallary = true"
            @update-items="updateItems"
          />
        </div>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        v-if="feature.id != null"
        color="green darken-1"
        text
        @click="updateFeature"
      >
        更新する
      </v-btn>
      <v-btn v-else color="green darken-1" text @click="createFeature">
        作成する
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
import axios from 'axios'
import PostGallary from '@/components/commons/PostGallary'
import { mapState } from 'vuex'
import PostListSelectable from '@/components/commons/PostListSelectable'
import snakecaseKeys from 'snakecase-keys'
import InputLabel from '@/components/commons/formParts/inputLabel'
import formValidationUtils from '@/mixins/form_validation_utils'
import ImageFormAndThumbnail from '@/components/commons/ImageFormAndThumbnail'

export default {
  components: {
    PostGallary,
    PostListSelectable,
    InputLabel,
    ImageFormAndThumbnail
  },
  mixins: [formValidationUtils],
  props: {
    feature: {
      type: Object,
      required: true
    },
    dialog: {
      type: Boolean,
      required: true
    }
  },
  data: () => {
    return {
      postGallary: false
    }
  },
  computed: {
    ...mapState({
      featureI18ns: (state) => state.I18n.enums.feature
    }),
    pageTypes: function () {
      if (this.featureI18ns == null) {
        return []
      }
      const pageTypeI18n = snakecaseKeys(this.featureI18ns.pageType)
      const keys = Object.keys(pageTypeI18n)
      let pageTypes = []
      keys.forEach((key) => {
        pageTypes.push({ type: pageTypeI18n[key], value: key })
      })
      return pageTypes
    },
    postListPostIds: function () {
      let ids = []
      if (Object.keys(this.feature).length !== 0 && this.feature.featureItems !== null) {
        this.feature.featureItems.forEach((featureItem) => {
          if (featureItem.destroy == false) {
            ids.push(featureItem.post.id)
          }
        })
      }
      return ids
    },
    displayForm: {
      get () {
        return this.dialog
      },
      set (newVal) {
        if (newVal == false) {
          this.$emit('close-dialog')
          this.$refs.headlineImage.imageFile = null
          this.$refs.headlineImage.imagePreviewURL = null
          this.$refs.headlineImage3X2.imageFile = null
          this.$refs.headlineImage3X2.imagePreviewURL = null
          this.$refs.coverImage3X2.imageFile = null
          this.$refs.coverImage3X2.imagePreviewURL = null
          this.$emit('update-feature', {})
        }
      }
    }
  },
  methods: {
    formDataQuery () {
      const payload = snakecaseKeys(this.feature)
      let formData = new FormData()
      Object.keys(payload).forEach((key) => {
        if (payload[key] !== null) {
          if (key === 'headline_image') {
            formData.append(`feature[headline_image]`, this.feature.headlineImage)
          } else if (key === 'headline_image3_x2') {
            formData.append(`feature[headline_image_3x2]`, this.feature.headlineImage3X2)
          } else if (key === 'cover_image3_x2') {
            formData.append(`feature[cover_image_3x2]`, this.feature.coverImage3X2)
          } else {
            formData.append(`feature[${key}]`, payload[key])
          }
        }
      })
      if (payload.page_type == 'post_summarize') {
        if (payload.feature_items) {
          const featureItemsAttributes = payload.feature_items.map(
            (item, index) => {
              let obj = {
                order: index,
                post_id: item.post_id,
                _destroy: item.destroy
              }
              if (item.id) {
                Object.assign(obj, { id: item.id })
              }
              return obj
            }
          )
          featureItemsAttributes.forEach((item) => {
            Object.keys(item).forEach((key) => {
              if (item[key] !== null) {
                formData.append(
                  `feature[feature_items_attributes][][${key}]`,
                  item[key]
                )
              }
            })
          })
        }
      }
      return formData
    },
    createFeature () {
      if (!this.$refs.featureForm.validate()) {
        return false
      }
      const formData = this.formDataQuery()
      axios
        .post('/api/features', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(
          () => {
            const payload = {
              status: 200,
              message: '特集を作成しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
            this.$emit('fetch-features')
            this.$emit('close-dialog')
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    updateFeature () {
      if (!this.$refs.featureForm.validate()) {
        return false
      }
      const formData = this.formDataQuery()
      axios
        .patch(`/api/features/${this.feature.id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(
          () => {
            const payload = {
              status: 200,
              message: '更新しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
            this.$emit('fetch-features')
            this.$emit('close-dialog')
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    selectPost (post) {
      const postIdAndDestroys = this.feature.featureItems.map(
        (item) => {
          return { id: item.postId, destroy: item.destroy }
        }
      )
      const checkOldPost = postIdAndDestroys.find(
        (item) => item.id === post.id && item.destroy === false
      )
      if (checkOldPost) {
        const payload = {
          status: 500,
          message: 'この記事はすでに選択されています。'
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      } else {
        this.changeDestroyOrAddPost(post)
      }
    },
    changeDestroyOrAddPost (post) {
      const postIds = this.feature.featureItems.map(
        (item) => item.postId
      )
      if (postIds.includes(post.id)) {
        this.feature.featureItems.find(
          (item) => item.postId === post.id
        ).destroy = false
      } else {
        this.feature.featureItems.push({
          postId: post.id,
          post: post,
          destroy: false
        })
      }
    },
    updateItems (value) {
      this.feature.featureItems = value
    }
  }
}
</script>

<style scoped></style>
